import {
  ContentBlockKind,
  CopilotConversionItemType,
  CopilotManagerPromptType,
} from 'models/copilot/copilotConversation';
import { KeyValuePair } from 'utils/array';
import IdListDTO from '../IdListDTO';

export class CopilotConversationDTO {
  id?: string;

  request?: CopilotConversationItemDTO;

  thread: CopilotConversationItemDTO[];

  constructor() {
    this.thread = [];
  }
}

export class CopilotResponseAnnotationsDTO {
  citations?: PromptResponseCitationDTO[];

  metadata?: KeyValuePair[];
}

export class CopilotConversationBaseItemDTO extends CopilotResponseAnnotationsDTO {
  question?: string;

  context?: string;

  promptType?: CopilotManagerPromptType;

  response?: string;

  selectedEntityIds?: IdListDTO;

  link?: string;

  contentBlocks?: CopilotConversationContentBlockDTO[];
}

export class CopilotConversationContentBlockDTO {
  id?: string;

  kind: ContentBlockKind;

  version: number;

  created?: string;

  title?: string;

  text?: string;

  link?: string;

  savedLibraryListId?: number;

  savedLibraryLinkId?: number;

  adaptiveCardJson?: string;

  dataTable?: CopilotDataTableContentDTO;

  adaptiveInputs?: Record<string, string>;

  payload?: unknown;

  mimeType?: string;

  sourceUrl?: string;

  constructor() {
    this.kind = ContentBlockKind.Markdown;
    this.version = 0;
  }
}

export class CopilotDataTableContentDTO {
  columns: CopilotDataTableColumnDTO[];

  rows: Record<string, unknown>[];

  page: number;

  pageSize: number;

  totalCount: number;

  returnedCount?: number;

  isTruncated?: boolean;

  maxReturnedRows?: number;

  constructor() {
    this.columns = [];
    this.rows = [];
    this.page = 0;
    this.pageSize = 0;
    this.totalCount = 0;
  }
}

export class CopilotDataTableColumnDTO {
  key: string;

  name: string;

  dataType?: string;

  constructor() {
    this.key = '';
    this.name = '';
  }
}

export class CopilotConversationItemDTO extends CopilotConversationBaseItemDTO {
  id?: string;

  type: CopilotConversionItemType;

  date?: string;

  userId?: string;

  constructor() {
    super();
    this.type = CopilotConversionItemType.User;
  }
}

export class PromptResponseCitationDTO {
  title?: string;

  uri?: string;
}
